import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import styles from 'styles/ai.module.css'

interface DifferanceProp {
  id: number
  parameter: string
  inhouse: string
  freelancing: string
}

interface DifferanceProps {
  sectionTitle: React.ReactNode
  sectionDescription: React.ReactNode
  differanceData: DifferanceProp[]
}

const Differance: React.FC<DifferanceProps> = ({
  sectionTitle,
  sectionDescription,
  differanceData,
}) => {
  return (
    <Container className={styles.commonPad}>
      <div className="row align-items-center mb-md-5 mb-3 pt-5">
        {sectionTitle}
        {sectionDescription}
      </div>
      <Row>
        <Col xs={12}>
          <div className="table-responsive 1111">
            <table className="SmarterApproch-table">
              <thead>
                <tr>
                  <th scope="col" className="custom-header-light small">
                    Feature
                  </th>
                  <th scope="col" className="custom-header-light small">
                    Traditional Marketing
                  </th>
                  <th scope="col" className="custom-header-light small">
                    AI-Driven Marketing
                  </th>
                </tr>
              </thead>
              <tbody>
                {differanceData.map((row, index) => (
                  <tr key={row.id} className="align-middle">
                    <td className="">
                      <div className="d-flex align-items-center">
                        <span className="parameter-number-badge d-none d-lg-flex">
                          {row.id}
                        </span>
                        <span className="parameter-title fs-16px fs-lg-20px">
                          {row.parameter}
                        </span>
                      </div>
                    </td>
                    <td className="inhouse-cell">
                      <span>{row.inhouse}</span>
                    </td>
                    <td className="freelancing-cell">
                      <span>{row.freelancing}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Differance
